import Account from "./Account"
import { H1 } from "@/ui/components"
import { useT } from "@/i18n"

export default function AccountPage() {
  const { t } = useT("auth")

  return (
    <div className="flex flex-col items-center justify-center py-8">
      <H1 className="mb-4">{t("myAccount")}</H1>
      <div className="sm:w-2/3 md:w-1/2">
        <Account />
      </div>
    </div>
  )
}
